import {FC} from 'react';
import UIIcon from './UIIcon';

type UIHeadingProps = {
  title: string;
  description: string;
  icon?: string;
  big?: boolean;
  longer?: boolean;
  date?: boolean;
  style?: string;
}

const UIHeading: FC<UIHeadingProps> = ({
  title,
  description,
  icon,
  big,
  longer,
  date,
  style,
}) => {
  const month = new Date().toLocaleString('sv-SV', {month: 'long'});
  const year = new Date().toLocaleString('sv-SV', {year: 'numeric'});
  const day = new Date().toLocaleString('sv-SV', {day: 'numeric'});
  const weekday = new Date().toLocaleString('sv-SV', {weekday: 'long'});

  return (
    <div className={`pt-8 flex justify-between items-start text-navy-primary ${style}`}>
      <div className={`${longer ? 'max-w-[360px]' : 'max-w-[270px]' } font-Outfit `}>
        <div className='flex'>
          <div className={'font-semibold ' + `${big ? 'text-26' : 'text-2xl'}`}>{title}</div>
          {icon && ( <UIIcon icon={icon} style='p-2 text-2xl'/> )}
        </div>
        <div className={'font-normal ' + `${big ? 'text-base leading-5' : 'text-sm leading-1'}`}>{description}</div>
      </div>
      {date && (
        <div className='hidden md:flex flex-col items-end font-Outfit'>
          <div className={`${big ? 'text-2xl' : 'text-sm'}` + ' font-bold'}>{day} {month} {year}</div>
          <div className={`${big ? 'text-lg' : 'text-sm'}` + ' leading-4'}>{weekday}</div>
        </div>
      )}
    </div>
  );
};

export default UIHeading;
